export default "__VITE_ASSET__CWs7ite9__"